import { useState, useEffect } from 'react';

import { Grid } from '@mui/material'
import { useSelector } from 'react-redux';
import UploadPoActionModalContainer from '../uploadPo/UploadPoActionModalContainer';

export default function ViewPOActionImpl() {
  const { poObj } = useSelector((state) => state.pharmaslice.poDashboard);
  const { editorderModalOpen } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
  const {mobileView} = useSelector((state)=>state.menu);

  useEffect(() => {
  }, [poObj])

  const getHeight = () =>{
    if (mobileView) return (window.screen.height*0.80-200)+'px';
    else
      return (window.screen.height*0.80-300)+'px';
  }
  return (
    <>
      <div >
        {poObj.popath ?
          <iframe
            src={`https://docs.google.com/gview?embedded=true&url=${poObj.popath}`}
            width="100%"
            height={getHeight()}
            style={{ border: 'none', }}
            title="PO @ {poObj.partyname}"
          />

          : <>
            {/* <UploadPoActionModalContainer/> */}
            <Grid
              container
              direction="row"
              sx={{
                justifyContent: "center",
                alignItems: "center",
              }}
              padding={1}
            >
              <Grid item sx={{backgroundColor:'white', height:'50px', width:{xs:'90%',lg:'100%'}, textAlign:'center'}}>
              PO is not uploaded yet
              </Grid>
            </Grid>

          </>}
      </div>

    </>
  )
}